const ERROR_SELECTOR = ".error, .failure, .alert";

export const NON_ERROR_TIMEOUT_MS = 5000;

interface FlashWindow extends Window {
  app?: unknown;
}

// Tracked here rather than on window so repeated initialisation can't double-bind.
const boundDocuments = new WeakSet<Document>();

// app.js binds click-to-dismiss and a timed retirement on every layout carrying the legacy
// asset bundle. Vite-only layouts (VM2) never load it, so they inherited the flash markup
// and none of its behaviour, leaving a fixed banner over the page foot indefinitely.
export const initFlashDismissal = (
  win: FlashWindow = window as FlashWindow,
  timeoutMs: number = NON_ERROR_TIMEOUT_MS,
): void => {
  if (win.app) return;

  const doc = win.document;
  const flashes = () => Array.from(doc.querySelectorAll<HTMLElement>(".flash"));

  if (!boundDocuments.has(doc)) {
    boundDocuments.add(doc);
    doc.addEventListener("click", (event) => {
      const dismiss = (event.target as Element | null)?.closest?.(".flash-dismiss");
      if (dismiss) {
        dismiss.closest(".flash")?.remove();
        return;
      }
      flashes().forEach((flash) => flash.remove());
    });
  }

  flashes().forEach((flash) => {
    // An error is the only report of what went wrong, so it waits to be dismissed.
    if (flash.querySelector(ERROR_SELECTOR)) return;
    win.setTimeout(() => flash.remove(), timeoutMs);
  });
};
